<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl" label="登录用户名" prop="loginUserName">
        <el-input v-model.trim="queryParams.loginUserName" placeholder="请输入登录用户名" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl" label="登录ip地址" prop="loginIp">
        <el-input v-model.trim="queryParams.loginIp" placeholder="请输入登录ip地址" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl" label="渠道" prop="loginChannel">
        <el-select-dict dictType="CHANNEL" clearable placeholder="请选择渠道" v-model="queryParams.loginChannel"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl" label="状态" prop="status">
        <el-select-dict dictType="SUCCESS_FAIL" clearable placeholder="请选择状态" v-model="queryParams.status"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl" label="登录时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['log:login:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>

        <el-button v-hasPermission="['log:login:deleteAll']" class="fr" type="danger" icon="el-icon-delete"
          size="mini" @click="handleDeleteAll">全部删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="loginLogTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
          v-loading="loading" :data="list" row-key="logId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
          <el-table-column-dict maskType="mobile" label="登录用户名" prop="loginUserName" align="center" min-width="200px" />
          <el-table-column-dict :maskStart="4" :maskEnd="4" label="登录ip地址" prop="loginIp" align="center" min-width="200px" />
          <el-table-column label="请求URL" prop="apiUrl" align="center" min-width="300px" show-overflow-tooltip />
          <el-table-column-dict dictType="CHANNEL" dictTypeNode="tag" label="渠道" align="center" prop="loginChannel"
            min-width="100px"></el-table-column-dict>
          <el-table-column-dict dictType="SUCCESS_FAIL" dictTypeNode="tag" label="状态" align="center" prop="status"
            min-width="100px"></el-table-column-dict>
          <el-table-column-dict dateFormat="datetime" label="登录日期" align="center" prop="loginTime"
            min-width="168px"></el-table-column-dict>
          <el-table-column v-if="
            mixinHasPermi([
              'log:login:read',
            ])
          " label="操作" align="center" width="128px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermission="['log:login:read']" size="mini" type="primary" icon="el-icon-view"
                @click.native.stop="getDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>

    <login-log-dialog ref="loginLogDialog" title="日志详情" width="996px" :visible.sync="open" :modal-append-to-body="false"
      :close-on-click-modal="false" :baseForm="baseForm" @close="open = false"></login-log-dialog>
  </div>
</template>

<script>
import { logApi } from "@/api"
import LoginLogDialog from "./components/login-log-dialog.vue"
export default {
  name: "logLoginManage",
  components: {
    LoginLogDialog
  },
  data() {
    return {
      //搜索条件参数
      queryParams: {
        loginUserName: "", // 登录用户名称
        loginIp: "", // 登录ip地址
        status: "", // 登录状态
        loginChannel: "", // 登录所属渠道
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      loading: false,
      total: 0,
      open: false,

      // 非多个禁用(0个禁用)
      multiple: true,
      selection: [], // 选中的列表数据

      // 表单参数
      baseForm: {
        loginUserName: "", // 登录用户名
        loginIp: "", // 登录IP地址
        apiUrl: "", // 接口请求地址
        status: "", // 请求状态
        loginMsg: "", // 请求提示语
        loginTime: "", // 登录时间
        responseTime: "", // 接口响应时间
        loginLocationCountry: "", // 登录地址(国家)
        loginLocationCity: "", // 登录地址(城市)
        loginLocationRegion: "", // 登录地址(区域)
        loginLocationLatitude: "", // 登录地址(经度)
        loginLocationLongitude: "", // 登录地址(纬度)
        browser: "" // 登录设备信息
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    // 删除全部登录日志
    handleDeleteAll() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      this.$modal
        .confirm("删除后不可找回，是否确认删除全部登录日志？")
        .then(function() {
          return logApi.deleteAllLoginLog()
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("删除全部登录日志成功")
        })
        .catch(() => { })
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.logId)

      }

      this.$modal
        .confirm("删除后不可找回，是否确认删除已选择的数据项？")
        .then(function() {
          return logApi.batchDeleteLoginLog({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除登录日志成功")
        })
        .catch(() => { })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.multiple = !selection.length
    },
    //点击行
    clickRow(row) {
      this.$refs.loginLogTable.toggleRowSelection(row)
    },
    /** 搜索按钮登录 */
    handleQuery() {
      // 清空已选项
      this.$refs.loginLogTable.clearSelection()
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮登录 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询角色列表 */
    getList() {
      this.loading = true
      logApi
        .getLoginLogList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    /** 查看详情 */
    getDetail(row) {
      const id = row.logId
      logApi.getLoginLogDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    }
  }
}
</script>
